module.exports = __webpack_public_path__ + "img/public/SiteIcons/g648.svg?51869a2e";